import { isTrade, isVip } from 'chairisher/context/auth';

/**
 * Clarity tag constants
 * @enum {string}
 */
export const ClarityTags = {
    TRADE: 'trade',
    VIP: 'vip',
};

/**
 * Gets Clarity tags from the current context, or from optional data if provided
 *
 * @param {Object=} data Optional data object
 * @returns {Object} Object with key-value pairs for custom tags
 */
export function getClarityTags(data = null) {
    return {
        ...((data ? data.is_trade : isTrade()) && { [ClarityTags.TRADE]: 'true' }),
        ...((data ? data.is_vip_buyer : isVip()) && { [ClarityTags.VIP]: 'true' }),
    };
}

/**
 * Sets custom tags in Microsoft Clarity
 *
 * @param {Object} tags Object with key-value pairs for custom tags
 */
export function setClarityTags(tags) {
    if (!window.clarity) {
        return;
    }

    Object.entries(tags).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
            window.clarity('set', key, value);
        }
    });
}
